import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

import { Module, useWorkspaceBillingQuota } from '@/composables/billing/useWorkspaceBillingQuota';
import { formModeEnum } from '@/types/general';

const broadcastsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.broadcasts_trans',
  route: { name: 'broadcasts' },
});

const broadcasts_routes = [
  {
    path: '/broadcasts',
    name: 'broadcasts',
    redirect: { name: 'all-broadcasts' },
    component: () => import('@/views/System/Broadcasts/BroadcastsView.vue'),
    meta: {
      header: {
        title: 'GLOBAL.NAVS.broadcasts_trans',
        icon: 'bvi-announcement',
      },
      sidebar: [
        {
          icon: 'bvi-announcement',
          title: 'global.sidebar.all-broadcasts_trans',
          route: { name: 'all-broadcasts' },
          permissions: 'read-broadcasts',
        },
        {
          icon: 'bvi-whatsapp-colored',
          title: 'global.sidebar.whatsapp_trans',
          route: { name: 'whatsapp-broadcasts' },
          permissions: 'read-broadcasts',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'all-broadcasts',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-list/BroadcastsList.vue'),
        meta: {
          permissions: 'read-broadcasts',
          breadcrumbs: broadcastsBreadcrumbs(),
        },
      },
      {
        path: 'whatsApp',
        name: 'whatsapp-broadcasts',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-list/BroadcastsList.vue'),
        meta: {
          permissions: 'read-broadcasts',
          channelType: 'WhatsAppChannel',
          breadcrumbs: broadcastsBreadcrumbs({
            label: 'global.sidebar.whatsapp_trans',
            route: { name: 'whatsapp-broadcasts' },
          }),
        },
      },
      {
        path: 'add',
        name: 'broadcast-add',
        async beforeEnter() {
          const quota = useWorkspaceBillingQuota(Module.BROADCAST);
          if (!quota.fetchAttempted.value) {
            await quota.fetchQuota();
          }
        },
        component: () => import('@/views/System/Broadcasts/partials/broadcast-form/BroadcastForm.vue'),
        meta: {
          formType: formModeEnum.ADD,
          permissions: 'write-broadcasts',
          breadcrumbs: broadcastsBreadcrumbs(),
        },
      },
      {
        path: ':id/edit',
        name: 'broadcast-edit',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-form/BroadcastForm.vue'),
        meta: {
          formType: formModeEnum.EDIT,
          permissions: 'update-broadcasts',
          breadcrumbs: broadcastsBreadcrumbs(),
        },
      },
      {
        path: ':id',
        name: 'broadcast-show',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-details/BroadcastDetails.vue'),
        meta: {
          permissions: 'read-broadcasts',
          breadcrumbs: broadcastsBreadcrumbs(),
        },
      },
    ],
  },
];

export default broadcasts_routes;
